<script lang="ts">
  import type { NewsRunningLane } from '$lib/sanity/schemas';
  import RunningLane from '$components/News/RunningLane.svelte';
  import { type ContentSourceMap, type StudioPathLike } from '@sanity/svelte-loader';

  interface Props {
    document: NewsRunningLane;
    sourceMap?: ContentSourceMap | undefined;
    path?: StudioPathLike;
  }

  let { document, sourceMap = undefined, path = [] }: Props = $props();
</script>

<RunningLane {sourceMap} path={[...path, 'content']} content={document.content} />
